{
  "version": 1,
  "asset_id": "99419ee2-3695-4494-be3a-a6dbbd3cc139",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/99419ee2-3695-4494-be3a-a6dbbd3cc139/maintenance-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/99419ee2-3695-4494-be3a-a6dbbd3cc139/maintenance-thumb.webp",
  "original_filename": "maintenance-thumb.webp",
  "size": 2572,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:00Z"
}
